import axios from 'axios';

export interface ResponseDataType<T> {
  code: number;
  msg: string | string[];
  info?: T;
}

async function returnResponseData(
  response: any,
  callback: () => void
): Promise<any> {
  if (response.data.code === -1001) {
    if (await refreshToken()) return;

    return await callback();
  }

  return response.data;
}

export async function postRequest(
  url: string,
  body?: any,
  type: 'form-data' | 'json' = 'json'
): Promise<any> {
  try {
    let response = await axios.post(
      process.env.REACT_APP_BASE_URL + '/api' + url,
      body,
      type === 'json'
        ? generateRequestHeader()
        : generateRequestFormDataHeader()
    );

    return returnResponseData(
      response,
      async () => await postRequest(url, body, type)
    );
  } catch (error: any) {
    return error?.response?.data;
  }
}
export async function patchRequest(
  url: string,
  body?: any,
  type: 'form-data' | 'json' = 'json'
): Promise<any> {
  try {
    let response = await axios.patch(
      process.env.REACT_APP_BASE_URL + '/api' + url,
      body,
      type === 'json'
        ? generateRequestHeader()
        : generateRequestFormDataHeader()
    );

    return returnResponseData(
      response,
      async () => await patchRequest(url, body, type)
    );
  } catch (error: any) {
    return error?.response?.data;
  }
}
export async function putRequest(
  url: string,
  body?: any,
  type: 'form-data' | 'json' = 'json'
): Promise<any> {
  try {
    let response = await axios.put(
      process.env.REACT_APP_BASE_URL + '/api' + url,
      body,
      type === 'json'
        ? generateRequestHeader()
        : generateRequestFormDataHeader()
    );

    return returnResponseData(
      response,
      async () => await putRequest(url, body, type)
    );
  } catch (error: any) {
    return error?.response?.data;
  }
}

export async function getRequest(url: string): Promise<any> {
  try {
    let response = await axios.get(
      process.env.REACT_APP_BASE_URL + '/api' + url,
      generateRequestHeader()
    );

    return returnResponseData(response, async () => await getRequest(url));
  } catch (error: any) {
    return error?.response?.data;
  }
}

// export async function deleteRequest(url: string): Promise<any> {
//   try {
//     let response = await axios.delete(
//       process.env.REACT_APP_BASE_URL + '/api' + url,
//       generateRequestHeader()
//     );

//     return returnResponseData(response, async () => await deleteRequest(url));
//   } catch (error: any) {
//     return error?.response?.data;
//   }
// }
export async function downloadRequest(url: string, filename: string): Promise<any> {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL + '/api' + url,
      {
        ...generateRequestHeader(),
        responseType: 'blob',
      }
    );

    const blob = new Blob([response.data]);
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobUrl);
    return true;
  } catch (error: any) {
    return false;
  }
}

export async function deleteRequest(
  url: string,
  body?: any,
  type: 'json' | 'form-data' = 'json'
): Promise<any> {
  try {
    const config =
      type === 'json'
        ? generateRequestHeader()
        : generateRequestFormDataHeader();

    const response = await axios.delete(
      process.env.REACT_APP_BASE_URL + '/api' + url,
      {
        ...config,
        data: body, // 💡 Axios DELETE body nằm trong config.data
      }
    );

    return returnResponseData(
      response,
      async () => await deleteRequest(url, body, type)
    );
  } catch (error: any) {
    return error?.response?.data;
  }
}
export async function postDirect(
  url: string,
  body?: any,
  customHeaders?: Record<string, string>,
  type: "form-data" | "json" = "json"
): Promise<any> {
  try {
    // Header mặc định (giống postRequest)
    const baseHeaders =
      type === "json" ? generateRequestHeader() : generateRequestFormDataHeader();

    // Merge với headers custom
    const mergedConfig = {
      ...baseHeaders,
      headers: {
        ...baseHeaders.headers,
        ...(customHeaders || {}),
      },
    };

    const response = await axios.post(
      process.env.REACT_APP_BASE_URL + "/api" + url,
      body,
      mergedConfig
    );

    return returnResponseData(
      response,
      async () => await postDirect(url, body, customHeaders, type)
    );
  } catch (error: any) {
    return error?.response?.data;
  }
}

export function generateRequestHeader() {
  return {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    },
  };
}

export function generateRequestFormDataHeader() {
  return {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    },
  };
}

export async function refreshToken() {
  try {
    const response = await axios.post(
      process.env.REACT_APP_BASE_URL + '/api/cms/auth/customer/refreshToken',
      {
        refreshToken: localStorage.getItem('refreshToken'),
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.data.code === 200) {
      localStorage.setItem('accessToken', await response.data.info);
    } else {
      localStorage.removeItem('email');
      localStorage.removeItem('uid');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('role');
      window.location.href = '/login?';
      return true;
    }
  } catch (error) { }
}
